import React from 'react';
import Fade from "react-reveal/Fade";
import { Fullpage, HorizontalSlider, Slide } from "fullpage-react";
import { navigateTo } from "gatsby-link";
const { changeFullpageSlide } = Fullpage;



const fullPageOptions = {
    scrollSensitivity: 1,
    touchSensitivity: 1,
    scrollSpeed: 200,
    resetSlides: true,
    hideScrollBars: true,
    enableArrowKeys: true,
    activeSlide: 0,
};



class PortofolioIndexPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            active: {
                Fullpage: 0,
            }
        };

        this.onSlideChangeStart = this.onSlideChangeStart.bind(this);
        this.onSlideChangeEnd = this.onSlideChangeEnd.bind(this);
    }

    onSlideChangeStart(name, props, state, newState) {
    }

    onSlideChangeEnd(name, props, state, newState) {

        const oldActive = this.state.active;
        const sliderState = {
            [name]: newState.activeSlide
        };

        const updatedState = Object.assign(oldActive, sliderState);
        this.setState(updatedState);;
    }

    componentDidMount() {

    }

    componentWillUnmount() {
        document.body.style.overflow = 'auto';
        document.documentElement.style.overflow = 'auto';
    }


    render() {
        const { active } = this.state;

        const currentActive = active.Fullpage;
        const prevSlide = changeFullpageSlide.bind(null, currentActive - 1);
        const nextSlide = changeFullpageSlide.bind(null, currentActive + 1);
        const goToTop = changeFullpageSlide.bind(null, 0);

        const studySmartImg = require("../../assets/img/projects/studysmart/main-ss.png");
        const laminarImg = require("../../assets/img/projects/laminardata/ss2.png");
        const tstImg = require("../../assets/img/projects/tst/ss.png");
        const amImg = require("../../assets/img/projects/adrianmanduc/ss.png");
        const tpImg = require("../../assets/img/projects/tudorpirvu/ss.png");
        const cuvinteImg = require("../../assets/img/projects/cuvinte/ss.png");
        const cuvinteImg2 = require("../../assets/img/projects/cuvinte/ss2.png");
        const strImg = require("../../assets/img/projects/str/ss.png");
        const rcImg = require("../../assets/img/projects/rc/ss.jpg");
        const rcImg2 = require("../../assets/img/projects/rc/ss2.jpg");
        const sotoniteImg = require("../../assets/img/projects/sotonite/ss.png");
        const sotoniteImg2 = require("../../assets/img/projects/sotonite/ss1.png");
        const tbImg = require("../../assets/img/projects/tb/ss.png");
        const tbImg2 = require("../../assets/img/projects/tb/ss2.png");
        const verticalSlides = [
            <Slide id="slide-ss">
                <div className="slide-img"></div>
                <div className="slide-content">
                    <div>
                        <h2 className="slide-title">
                            Study Smart
                            </h2>
                        <div className="slide-description">
                            A private tutoring management system
                            </div>
                        <div className="slide-image">
                            <img src={studySmartImg} />
                        </div>
                        <div className="slide-tags">
                            <span>#AngularJS</span>
                            <span>#NodeJS</span>
                            <span>#MongoDB</span>
                            <span>#Ionic</span>
                        </div>
                        <div className="slide-button">
                            <button onClick={() => navigateTo('/portofolio/studysmart')} className="btn">Details</button>
                        </div>
                    </div>
                </div>

            </Slide >,
            <Slide id="slide-laminar">
                <div className="slide-img"></div>
                <div className="slide-content">
                    <div>
                        <h2 className="slide-title">
                            Demo Application for Laminar Data
                            </h2>
                        <div className="slide-description">
                            A web application which   highlights the business value of Laminar Data – a cloud-based RESTful API dedicated to managing flight, weather and aeronautical data.
                            </div>
                        <div className="slide-image">
                            <img src={laminarImg} />
                        </div>
                        <div className="slide-tags">
                            <span>#AngularJS</span>
                            <span>#Flask</span>
                        </div>
                        <div className="slide-button">
                            <button onClick={() => navigateTo('/portofolio/laminar')} className="btn">Details</button>
                        </div>
                    </div>
                </div></Slide>,
            <Slide id="slide-tst">  <div className="slide-img"></div>
                <div className="slide-content">
                    <div>
                        <h2 className="slide-title">
                            TvShowTrack
                            </h2>
                        <div className="slide-description">
                            A TV Series tracker
                            </div>
                        <div className="slide-image">
                            <img src={tstImg} />
                        </div>
                        <div className="slide-tags">
                            <span>#Angular</span>
                            <span>#AngularUniversal</span>
                            <span>#NodeJS</span>
                        </div>
                        <div className="slide-button">
                            <button className="btn">Details</button>
                        </div>
                    </div>
                </div></Slide>,
            <Slide id="slide-am">
                <div className="slide-img"></div>
                <div className="slide-content">
                    <div>
                        <h2 className="slide-title">
                            adrianmanduc.com
                            </h2>
                        <div className="slide-description">
                            Personal website
                            </div>
                        <div className="slide-image">
                            <img src={amImg} />
                        </div>
                        <div className="slide-tags">
                            <span>#React</span>
                            <span>#GatsbyJS</span>
                        </div>
                      {/*   <div className="slide-button">
                            <button className="btn">Details</button>
                        </div> */}
                    </div>
                </div>
            </Slide>,
            <Slide id="slide-tp">
                <div className="slide-img"></div>
                <div className="slide-content">
                    <div>
                        <h2 className="slide-title">
                            tudorpirvu.com
                            </h2>
                        <div className="slide-description">
                            Personal website
                            </div>
                        <div className="slide-image">
                            <img src={tpImg} />
                        </div>
                        <div className="slide-tags">
                            <span>#Angular</span>
                        </div>
                        <div className="slide-button">
                            <button className="btn" onClick={() => window.open("https://adrianmanduc.github.io/tudorpirvu.com", "_blank")}>View Website</button>
                        </div>
                    </div>
                </div>
            </Slide>,
            <Slide id="slide-cuvinte">
                <div className="slide-img"></div>
                <div className="slide-content">
                    <div>
                        <h2 className="slide-title">
                            Cuvinte!
                            </h2>
                        <div className="slide-description">
                            Cross-platform mobile multiplayer word game
                            </div>
                        <div className="slide-image">
                            <img src={cuvinteImg2} />
                            <img src={cuvinteImg} />
                        </div>
                        <div className="slide-tags">
                            <span>#Ionic</span>
                            <span>#Angular</span>
                            <span>#NodeJS</span>
                            <span>#Socket.io</span>
                        </div>
                        <div className="slide-button">
                            <button onClick={() => navigateTo('/portofolio/cuvinte')} className="btn">Details</button>
                        </div>
                    </div>
                </div>
            </Slide>,
            <Slide id="slide-sotonite" >
                <div className="slide-img"></div>
                <div className="slide-content">
                    <div>
                        <h2 className="slide-title">
                            Sotonite
                            </h2>
                        <div className="slide-description">
                            A mobile application that helps University of Southampton students find information about various points of interests or facilities
                            </div>
                        <div className="slide-image">
                              <img src={sotoniteImg} />
                            <img src={sotoniteImg2} />
                        </div>
                        <div className="slide-tags">
                            <span>#Ionic</span>
                            <span>#NodeJS</span>
                        </div>
                        <div className="slide-button">
                            <button className="btn">Details</button>
                        </div>
                    </div>
                </div>
            </Slide>,
            <Slide id="slide-str" >
                <div className="slide-img"></div>
                <div className="slide-content">
                    <div>
                        <h2 className="slide-title">
                            Sea Temperature Romania
                            </h2>
                        <div className="slide-description">
                            Sea water temperature tracker for the most popular Romanian locations
                            </div>
                        <div className="slide-image">
                            <img src={strImg} />
                        </div>
                        <div className="slide-tags">
                            <span>#Ionic</span>
                            <span>#NodeJS</span>
                        </div>
                        <div className="slide-button">
                            <button className="btn" onClick={() => window.open("https://play.google.com/store/apps/details?id=com.agm.sea_temperature_romania&hl=en", "_blank")}>View App</button>
                        </div>
                    </div>
                </div>
            </Slide>,
            <Slide id="slide-rc">
                <div className="slide-img"></div>
                <div className="slide-content">
                    <div>
                        <h2 className="slide-title">
                            RailCheck
                            </h2>
                        <div className="slide-description">
                            Event Driven Wireless Sensor Networks - prototype for a railway embankment monitoring system
                            </div>
                        <div className="slide-image">
                            <img src={rcImg} />
                            <img src={rcImg2} />
                        </div>
                        <div className="slide-tags">
                            <span>#Ionic(V1)</span>
                            <span>#AngularJS</span>
                            <span>#NodeJS</span>
                        </div>
                        <div className="slide-button">
                            {/* <button className="btn">Details</button> */}
                        </div>
                    </div>
                </div>
            </Slide>,
            <Slide id="slide-tb" >
                <div className="slide-img"></div>
                <div className="slide-content">
                    <div>
                        <h2 className="slide-title">
                            Taxi Bucharest
                            </h2>
                        <div className="slide-description">
                            A mobile app with list of the taxi numbers from Bucharest
                            </div>
                        <div className="slide-image">
                            <img src={tbImg} />
                            <img src={tbImg2} />
                        </div>
                        <div className="slide-tags">
                            <span>#Ionic</span>
                            <span>#Angular</span>
                        </div>
                        <div className="slide-button">
                            <button className="btn" onClick={() => window.open("https://play.google.com/store/apps/details?id=com.agm.taxi_bucharest&hl=en", "_blank")}>View App</button>
                        </div>
                    </div>
                </div>
            </Slide>
        ];
        fullPageOptions.slides = verticalSlides;

        return (
            <div className="portofolio-wrapper">
                <ul>
                    <li className={currentActive == 0 ? 'active' : ''}><a onClick={changeFullpageSlide.bind(null, 0)}><span></span><h4>StudySmart</h4></a></li>
                    <li className={currentActive == 1 ? 'active' : ''}><a onClick={changeFullpageSlide.bind(null, 1)} ><span></span><h4>Laminar Data Demo</h4></a></li>
                    <li className={currentActive == 2 ? 'active' : ''}><a onClick={changeFullpageSlide.bind(null, 2)} > <span></span><h4>TvShowTrack</h4></a></li>
                    <li className={currentActive == 3 ? 'active' : ''}><a onClick={changeFullpageSlide.bind(null, 3)} ><span></span><h4>adrianmanduc.com</h4></a></li>
                    <li className={currentActive == 4 ? 'active' : ''}><a onClick={changeFullpageSlide.bind(null, 4)} ><span></span><h4>tudorpirvu.com</h4></a></li>
                    <li className={currentActive == 5 ? 'active' : ''}><a onClick={changeFullpageSlide.bind(null, 5)} ><span></span><h4>Cuvinte!</h4></a></li>
                    <li className={currentActive == 6 ? 'active' : ''}><a onClick={changeFullpageSlide.bind(null, 6)}><span></span><h4>Sotonite</h4></a></li>
                    <li className={currentActive == 7 ? 'active' : ''}><a onClick={changeFullpageSlide.bind(null, 7)}><span></span><h4>Sea Temperature Romania</h4></a></li>
                    <li className={currentActive == 8 ? 'active' : ''}><a onClick={changeFullpageSlide.bind(null, 8)} ><span></span><h4>Railcheck</h4></a></li>
                    <li className={currentActive == 9 ? 'active' : ''}><a onClick={changeFullpageSlide.bind(null, 9)} ><span></span><h4>Taxi Bucharest</h4></a></li>

                </ul>
                {currentActive != '9' && <div className="next-slide">
                    <a onClick={nextSlide} className="go-down">More projects below</a>
                </div>}
                <Fullpage onSlideChangeStart={this.onSlideChangeStart} onSlideChangeEnd={this.onSlideChangeEnd} {...fullPageOptions}>

                </Fullpage>

            </div>
        );
    }
}


export default PortofolioIndexPage;


// WEBPACK FOOTER //
// ./src/pages/portofolio/index.js